import React, { useCallback } from 'react';

import DueDateChip from '../chips/DueDateChip';
import TaskItemDueDatePopupContent from '../chips/TaskItemDueDatePopupContent';
import type { ElementDueDateChipDescriptor } from '../elementChipsTypes';
import type { TaskItemDueDate } from '../../../../common/tiptap/extensions/taskList/taskListItemChipTypes';
import type { UpdateTaskItemAttrs } from '../taskItemChipsUtils';
import { ChipBaseProps } from '../../../../common/@roma/src/components/base/chip/ChipBase';

type TaskItemDueDateChipProps = {
    chip: ElementDueDateChipDescriptor;
    size: ChipBaseProps['size'];
    dueDate: TaskItemDueDate | null;
    updateAttributes: UpdateTaskItemAttrs;
    canModify: boolean;
};

/**
 * Due-date chip for a Tiptap task item. The popup's node-attr editor writes go
 * through the owning node's `updateAttributes` (like the other task-item chips)
 * rather than the element-id popup the element chip uses. Clearing from the open
 * popup keeps the "Set due date" placeholder chip visible (mirrors
 * removeElementDueDate).
 */
const TaskItemDueDateChip: React.FC<TaskItemDueDateChipProps> = ({
    chip,
    size,
    dueDate,
    updateAttributes,
    canModify,
}) => {
    const onRemove = useCallback(() => {
        if (!canModify) return;

        updateAttributes({ dueDate: null, showDueDate: false });
    }, [canModify, updateAttributes]);

    return (
        <DueDateChip
            chip={chip}
            size={size}
            canModify={canModify}
            onRemove={onRemove}
            renderPopupContent={() => (
                <TaskItemDueDatePopupContent
                    dueDate={dueDate}
                    onChange={(newDueDate) => updateAttributes({ dueDate: newDueDate, showDueDate: true })}
                    onClear={() => updateAttributes({ dueDate: null, showDueDate: true })}
                />
            )}
        />
    );
};

export default TaskItemDueDateChip;
